// extracted by mini-css-extract-plugin
export var placeholder = "EmbedCode-module--placeholder--bbe74";
export var wrapper = "EmbedCode-module--wrapper--f82d1";